<div class="modal-header">
  <h4 class="modal-title">
    <i class="fa fa-users"></i> {{ 'Suggested Successors' | translate }}
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <!-- Loading Spinner -->
  <div *ngIf="isLoading" class="text-center">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ 'Loading' | translate }}...</span>
    </div>
  </div>

  <!-- Suggested Successors List -->
  <div *ngIf="!isLoading && suggestedSuccessors.length > 0; else noSuccessors">
    <ul class="list-group">
      <li *ngFor="let successor of suggestedSuccessors" class="list-group-item d-flex justify-content-between align-items-center">
        
        <!-- Profile Section -->
        <div class="d-flex align-items-center">
          <img 
            [src]="successor.image || 'assets/images/user-placeholder.jpg'" 
            alt="{{ successor.full_name }}" 
            class="rounded-circle me-3 shadow-md border"
            width="50"
            height="50"
          />
          <div>
            <strong>
              <i class="fa fa-user text-primary"></i> {{ successor.full_name }}
            </strong><br />
            <small class="text-muted">
              <i class="fa fa-building text-secondary"></i> {{ successor.department || 'Not Assigned' }}
            </small><br />
            <small class="text-muted">
              <i class="fa fa-briefcase text-success"></i> {{ successor.position || 'Position Not Defined' }}
            </small>
          </div>
        </div>

        <!-- Match Information -->
        <div>
          <span class="badge bg-success">
            <i class="fa fa-check-circle"></i> {{ successor.match_percentage }}% {{ 'Match' | translate }}
          </span>
          <p class="mb-0 small text-muted cursor-pointer" (click)="openSkillsModal(successor)">
            <i class="fa fa-check text-success"></i> {{ successor.matched_skills.length }} {{ 'Matched Skills' | translate }}
          </p>
          
          <p *ngIf="successor.unmatched_skills.length > 0" class="mb-0 small text-danger cursor-pointer" (click)="openSkillsModal(successor)">
            <i class="fa fa-times text-danger"></i> {{ successor.unmatched_skills.length }} {{ 'Unmatched Skills' | translate }}
          </p>          
        </div>     

        <!-- Action Buttons -->
        <div class="btn-group">
          <a target="_blank" [routerLink]="['/hr/employees/profile', successor.id]" class="btn btn-sm btn-outline-secondary">
            <i class="fa fa-user"></i> {{ 'Profile' | translate }}
          </a>
          <button class="btn btn-sm btn-primary" (click)="assignSuccessor(successor)" [disabled]="successor.already_assigned">
            <i class="fa fa-user-plus"></i> {{ successor.already_assigned ? ('Assigned' | translate) : ('Assign' | translate) }}
          </button>
        </div>
      </li>
    </ul>
  </div>

  <!-- No Successors Template -->
  <ng-template #noSuccessors>
    <p class="text-muted text-center">
      <i class="fa fa-info-circle"></i> {{ 'No suggested successors found.' | translate }}
    </p>
  </ng-template>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">
    <i class="fa fa-times"></i> {{ 'Close' | translate }}
  </button>
</div>
